<main *ngIf="isLoaded() && !hasFaturas()" class="fullheight">
  <p>
    <img src="assets/img/empty.png">
  </p>
  <h1>Nenhuma fatura disponível</h1>
  <p>Faturas com pagamento em aberto são exibidas aqui.</p>
</main>
<main *ngIf="hasFaturas()">
  <h1>Abertos</h1>
  <div *ngFor="let faturasAgrupadas of listaFaturas">
    <h2>
      {{faturasAgrupadas.header}}
    </h2>
    <eae-fatura-card *ngFor="let fatura of faturasAgrupadas.faturas" [fatura]="fatura"></eae-fatura-card>
  </div>
</main>
<ae-content-load *ngIf="!isLoaded()"></ae-content-load>
